import { LoanInvestorName } from '@willow/types-iso';

export const isOwnerIdGSE = (ownerId?: string | null): ownerId is LoanInvestorName =>
  LoanInvestorName.safeParse(ownerId).success;
